import { Editor, Column, ColumnEditor, EditorValidator } from 'angular-slickgrid';

declare var $: any;

export class CustomNumberOnlyEditor implements Editor {
    $input: any;
    selectedItem: object;
    constructor(private args: any) {
        this.init();
        this.selectedItem = args.item;
    }

    /** Get Column Definition object */
    get columnDef(): Column {
        return this.args && this.args.column || {};
    }

    /** Get Column Editor object */
    get columnEditor(): ColumnEditor {
        return this.columnDef && this.columnDef.internalColumnEditor || {};
    }

    get hasAutoCommitEdit() {
        return this.args.grid.getOptions().autoCommitEdit;
    }

    /** Get the Validator function, can be passed in Editor property or Column Definition */
    get validator(): EditorValidator {
        return this.columnEditor.validator || this.columnDef.validator;
    }

    init(): void {
        const scope = this;
        const maxLength = this.args.column.maxLength;
        const regex = this.args.column.regex ? this.args.column.regex : /[^0-9\.]/g;
        this.$input = $(`<input type="text" maxLength="` + maxLength + `" style="width: 100%;">`)
            .appendTo(this.args.container)
            .keyup(function () {
                this.value = regex ? this.value.replace(regex, '') : this.value;
                scope.columnDef['onChange'](this.value, scope.columnDef['scope']);
            }).on('blur', function (elem) {
                scope.applyValue(scope.selectedItem, $(elem.target).val());
                if (scope.columnDef['onChange']) {
                    scope.columnDef['onChange'](this.value, scope.columnDef['scope']);
                }
            }).focus();
    }

    destroy() {
    }

    focus() {
        this.$input.focus();
    }

    loadValue(item: any) {
        this.$input.val(item[this.args.column.field]);
    }

    serializeValue() {
        return this.$input.val();
    }

    applyValue(item: any, state: any) {
        item[this.args.column.field] = state;
    }
    isValueChanged() {
        return true;
    }
    validate() {
        return {
            valid: true,
            msg: null
        };
    }
}